import type { ClientOrganizationFact } from '@DigitaleDoerfer/digitale-doerfer-api';

import { AreaIcon, PopulationIcon } from '@/assets';
import type { SVGComponent } from '@/types';

export type TerritorialAuthorityStatId = 'einwohner' | 'flaeche';

export const TERRITORIAL_AUTHORITY_STAT_FACT_NAMES: Record<
  TerritorialAuthorityStatId,
  string[]
> = {
  einwohner: ['Einwohner', 'Einwohnerzahl'],
  flaeche: ['Fläche']
};

export const TERRITORIAL_AUTHORITY_STAT_ICONS: Record<
  TerritorialAuthorityStatId,
  SVGComponent
> = {
  einwohner: PopulationIcon,
  flaeche: AreaIcon
};

export type TerritorialAuthorityStat = {
  id: TerritorialAuthorityStatId;
  value: string;
  label: string;
  icon: SVGComponent;
};

export const splitFacts = (
  facts: ClientOrganizationFact[] | undefined
): { stats: TerritorialAuthorityStat[]; rest: ClientOrganizationFact[] } => {
  if (!facts) {
    return { stats: [], rest: [] };
  }

  const rest: ClientOrganizationFact[] = [];
  const stats: TerritorialAuthorityStat[] = [];

  for (const fact of facts) {
    const statId = (
      Object.keys(
        TERRITORIAL_AUTHORITY_STAT_FACT_NAMES
      ) as TerritorialAuthorityStatId[]
    ).find((id) =>
      TERRITORIAL_AUTHORITY_STAT_FACT_NAMES[id].includes(fact.name)
    );
    if (statId) {
      stats.push({
        id: statId,
        value: fact.value,
        label: fact.name,
        icon: TERRITORIAL_AUTHORITY_STAT_ICONS[statId]
      });
    } else {
      rest.push(fact);
    }
  }

  return { stats, rest };
};
